export default "__VITE_ASSET__BfWWk0e6__"